import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AgrNumberDirective } from '@next/core-lib/form';
import { Currency, CurrencySymbolPipe, TranslatePipe } from '@next/core-lib/i18n';

import { CostTotalForm } from './cost-total.model';

@Component({
  selector: 'app-cost-total',
  templateUrl: 'cost-total.component.html',
  styles: [
    `
      .flex-basis-0 {
        flex-basis: 0;
      }
    `,
  ],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatPrefix,
    MatInput,
    AgrNumberDirective,
    CurrencySymbolPipe,
    TranslatePipe,
  ],
})
export class CostTotalComponent implements OnChanges, OnInit {
  @Input() form: FormGroup<CostTotalForm>;
  @Input() currency: Currency;

  @Input() priceAmount?: number = null;
  @Input() priceAmountIncludingVat?: number = null;

  @Input() vaccinationAmount?: number = null;
  @Input() vaccinationAmountIncludingVat?: number = null;

  @Input() discountAmount?: number = null;
  @Input() discountAmountIncludingVat?: number = null;

  @Input() diverseAmount?: number = null;
  @Input() diverseAmountIncludingVat?: number = null;

  ngOnChanges(): void {
    this.calculateAmounts();
  }

  ngOnInit(): void {
    this.calculateAmounts();
  }

  calculateAmounts() {
    let amountExcludingVat = null;
    let amountIncludingVat = null;

    if (
      this.priceAmount !== null ||
      this.vaccinationAmount !== null ||
      this.discountAmount !== null ||
      this.diverseAmount !== null
    ) {
      amountExcludingVat =
        this.priceAmount + this.vaccinationAmount - this.discountAmount + this.diverseAmount;
    }

    if (amountExcludingVat !== null) {
      amountIncludingVat =
        this.priceAmountIncludingVat +
        this.vaccinationAmountIncludingVat -
        this.discountAmountIncludingVat +
        this.diverseAmountIncludingVat;
    }

    const totalAmount = Math.round(amountExcludingVat * 100) / 100;
    const totalAmountIncludingVat = Math.round(amountIncludingVat * 100) / 100;

    this.form.controls.calculatedAmounts.patchValue(totalAmount);
    this.form.controls.calculatedAmountsIncludingVat.patchValue(totalAmountIncludingVat);
  }
}
